import React, { ChangeEvent, useMemo, useState } from "react";
import {
  Grid,
  Paper,
  Button,
  Typography,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../redux/hooks";
import BasicModal from "../components/ui/BasicModal";
import Loader from "../components/ui/Loader";
import axios from "axios";
import { APIConstants } from "../constants/ApiConstants";
import theme from "../theme";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import backgroundImageToLogin from "../assets/loginBG.png";
import AlertMessage from "../components/ui/AlertMessage";
import CloseIcon from "@mui/icons-material/Close";
import { getUserFromURL } from "../components/forms/utility";
import PasswordRequireMents from "./ResetPassword/PasswordRequirements";
const paperStyle: React.CSSProperties = {
  width: "75%",
  borderRadius: "16px",
  height: "75%",
  overflow: "hidden",
};
const ResetPass = () => {
  const navigate = useNavigate();
  const [password, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showModel, setShowModal] = useState(false);
  const [modelError, setModelError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [enableButton, setEnableButton] = useState(false);
  const userTypeFromUrl = useMemo(() => getUserFromURL(), []);
  const handleClickShowPasswordConfirm = () =>
    setShowPasswordConfirm((show) => !show);
  const email = useAppSelector(
    (state: any) => state.persistReducers.resetPassword.email
  );
  const otpPersist = useAppSelector(
    (state: any) => state.persistReducers.otpSlice.otp
  );
  const handleNewPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmChange = (event: ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(event.target.value);
  };

  const handleResetPassword = async () => {
    if (password !== ConfirmPassword) {
      setError("Passwords don't match");
    } else {
      try {
        setLoading(true);
        const response = await axios.post(
          process.env.REACT_APP_API_URL + APIConstants.resetPassword,
          {
            email,
            otp: otpPersist,
            newPassword: password,
            user_type: userTypeFromUrl,
          }
        );

        const status = response.data.status;
        if (status) {
          setShowModal(true);
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        setError("Password not updated");

        setModelError(true);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  const onEnableButton = (value: boolean) => {
    setEnableButton(value);
  };

  return (
    <Grid
      display={"flex"}
      height={"100vh"}
      justifyContent={"space-around"}
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "space-around",
        opacity: 1,
        backgroundImage: `url(${backgroundImageToLogin})`,

        backgroundSize: "cover",
      }}
    >
      <Grid
        width={"40%"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img
          src={require("../assets/suntecLogo.png")}
          alt="Logo"
          style={{ maxWidth: "60%", maxHeight: "60%" }}
        />
      </Grid>
      <Grid
        width={"40%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        component={"form"}
      >
        <Paper
          style={paperStyle}
          elevation={9}
          sx={{
            justifyContent: "center",
          }}
        >
          <Grid height={"100%"} py={2} px={2}>
            <Grid display={"flex"} justifyContent={"right"}>
              <IconButton onClick={handleBackToLogin}>
                <CloseIcon
                  sx={{ color: theme.color?.newFilterGrey }}
                ></CloseIcon>
              </IconButton>
            </Grid>
            <Grid
              px={6}
              height={"85%"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Grid item xs={12}>
                <Typography
                  align="center"
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontWeight: theme.font?.fontWeight.thick,
                    fontSize: "32px",
                    textAlign: "left",
                    mb: 2,
                  }}
                >
                  New Password
                </Typography>
              </Grid>
              <Grid item xs={12} mb={2}>
                <Typography
                  sx={{
                    textAlign: "left",
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.tableHeader,
                    mb: "6px",
                  }}
                >
                  Password
                </Typography>
                <OutlinedInput
                  id="password"
                  label="New Password"
                  fullWidth
                  size="small"
                  value={password}
                  onChange={handleNewPasswordChange}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <PasswordRequireMents
                  password={password}
                  onEnableButton={onEnableButton}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography
                  sx={{
                    textAlign: "left",
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.tableHeader,
                    mb: "6px",
                  }}
                >
                  Confirm Password
                </Typography>
                <OutlinedInput
                  id="confirmPassword"
                  label="Confirm Password"
                  fullWidth
                  size="small"
                  value={ConfirmPassword}
                  onChange={handleConfirmChange}
                  type={showPasswordConfirm ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPasswordConfirm}
                        aria-label="toggle password visibility"
                      >
                        {showPasswordConfirm ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={12}>
                {error && (
                  <Typography
                    textAlign={"left"}
                    color={theme.color?.error}
                    align="center"
                    gutterBottom
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableBody,
                      mt: 0.5,
                    }}
                  >
                    {error}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="button"
                  variant="contained"
                  fullWidth
                  disabled={enableButton}
                  sx={{
                    color: theme.color?.background,
                    backgroundColor: theme.color?.secondary,
                    marginTop: 3,
                    textTransform: "capitalize",
                    boxShadow: "none",
                  }}
                  onClick={handleResetPassword}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
            {loading && <BasicModal content={<Loader />} />}
          </Grid>
        </Paper>
      </Grid>
      {showModel && (
        <AlertMessage
          title={
            "Your password has been reset successfully. Please login with your new password."
          }
          success={true}
          buttonTex="Login"
          setState={setShowModal}
          redirection="/login"
        />
      )}
      {modelError && (
        <AlertMessage
          title={
            "There was an error while updating password. Please try again."
          }
          success={false}
          buttonTex="Login"
          setState={setModelError}
          redirection="/login"
        />
      )}
    </Grid>
  );
};

export default ResetPass;
